import { useTranslation } from 'react-i18next';

import { Loader } from '@/components/Loader/loader';
import Slider from '@/components/Slider/Slider';
import { BREAKPOINTS } from '@/constants/breakpoints';
import useArbitrageSlides from '@/hooks/useArbitrageSlides';
import useScreenSize from '@/hooks/useScreenSize';

import styles from './ArbitrageSlider.module.css';

interface Props {
  className?: string;
  showTitle?: boolean;
}

const ArbitrageSlider = ({ className, showTitle }: Props) => {
  const { t } = useTranslation();
  const { windowWidth } = useScreenSize();
  const { arbitrageSlides, isArbitrageProposalsLoading } = useArbitrageSlides();

  if (!arbitrageSlides.length) return null;

  return (
    <div className={className ?? styles.wrapper}>
      {showTitle && <h2>{t('common.arbitrageProposals', { count: arbitrageSlides.length })}</h2>}
      {isArbitrageProposalsLoading ? (
        <Loader />
      ) : (
        <Slider
          slides={arbitrageSlides}
          direction="horizontal"
          slidesPerView={1}
          rows={1}
          breakpoints={{
            [BREAKPOINTS.mobile]: {
              grid: { rows: 2, fill: 'column' },
            },
          }}
          spaceBetween={20}
          loop
          autoplay={{ delay: 5000, disableOnInteraction: true }}
          height={arbitrageSlides.length > 2 ? 200 : 'auto'}
          showPagination={{ type: 'bullets' }}
          showNavigation={windowWidth >= BREAKPOINTS.tablet}
          showPlayPause={false}
        />
      )}
    </div>
  );
};

export default ArbitrageSlider;
